import {AvailableSearchTerms} from 'ocs-search-commons';

export const notaSearchItemsBuilder = (availableSearchTerms: AvailableSearchTerms) => {
  return [
    {
      nombre: 'Nombre del megaproyecto',
      dbname: 'proyectos',
      sourceType: 'compound',
      items: availableSearchTerms.proyectos,
      defaultLogicOp: 'o'
    },
    {
      nombre: 'Estado',
      dbname: 'estados',
      sourceType: 'compound',
      items: availableSearchTerms.estados,
      defaultLogicOp: 'o',
    },
    {
      nombre: 'Tipo de despliegue del capital',
      dbname: 'tipos_despliegue',
      sourceType: 'compound',
      items: availableSearchTerms.tipo_despliegue,
      defaultLogicOp: 'o'
    },
    {
      nombre: 'Oposición organizada',
      sourceType: 'compound',
      defaultLogicOp: 'y',
      items: availableSearchTerms.oposicion,
      dbname: 'oposicion',
    },
    {
      nombre: 'Formas de acción colectiva',
      sourceType: 'compound',
      items: availableSearchTerms.acciones_colectivas,
      dbname: 'acciones_colectivas',
      defaultLogicOp: 'y'
    },
    {
      nombre: 'Afectaciones ecológicas',
      sourceType: 'compound',
      items: availableSearchTerms.afectaciones_ecologicas,
      dbname: 'afectaciones_ecologicas',
      defaultLogicOp: 'y'
    },
    {
      nombre: 'Afectaciones sociales',
      dbname: 'afectaciones_sociales',
      sourceType: 'compound',
      items: availableSearchTerms.afectaciones_sociales,
      defaultLogicOp: 'y'
    },
    {
      nombre: 'Hechos de violencia',
      sourceType: 'compound',
      dbname: 'hechos_violencia',
      items: availableSearchTerms.hechos_violencia,
      defaultLogicOp: 'y'
    }
  ]
}
